<template>
  <v-row>
    <v-col>
      <v-file-input
        :label="caption"
        accept=".jpg, .png"
        :multiple="multipleImages"
        :error="error"
        :hint="hint"
        :persistent-hint="!!hint"
        :error-messages="errorMessages"
        :hide-details="!hint"
        @change="onFileChange"
      />
      <v-alert
        v-show="errorMessageCountDown"
        type="error"
        class="mt-2"
        closable
        :text="errorMessage"
      />
      <v-alert
        v-show="warningMessageCountDown"
        type="warning"
        class="mt-2"
        :text="warningMessage"
      />
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const props = withDefaults(defineProps<{
  onUploadImage: (_images: { id: null; data: string; title: string }[]) => void;
  caption?: string;
  hint?: string;
  multipleImages?: boolean;
  onUploadImageGuard: (_image: HTMLImageElement) => { hasError: boolean; errorMessage?: string; hasWarning: boolean; warningMessage?: string };
  errorMessages?: string | string[];
  error?: boolean;
}>(), {
  caption: () => useI18n().t('global.browse'),
  multipleImages: () => false,
});

const base64Images = ref<any>([]);
const errorMessage = ref('');
const warningMessage = ref('');
const errorMessageCountDown = ref(null);
const warningMessageCountDown = ref(null);

function createImage(file, totalFiles) {
  base64Images.value = [];
  const reader = new FileReader();
  reader.onload = (event) => {
    if (!event.target || typeof event.target.result !== 'string') {
      return;
    }
    const isFileImage = event.target.result.startsWith('data:image');
    if (isFileImage) {
      const img = new Image();
      img.src = event.target.result;

      img.onload = () => {
        if (props.onUploadImageGuard) {
          const outcome = props.onUploadImageGuard(img);
          if (outcome.hasError) {
            errorMessage.value = outcome.errorMessage ?? 'An error occurred';
            return;
          }
          if (outcome.hasWarning) {
            warningMessage.value = outcome.warningMessage ?? 'Warning: Check your file';
          }
        }
        base64Images.value.push({
          id: null,
          data: event.target.result,
          title: '',
        });
        if (base64Images.value.length === totalFiles) {
          props.onUploadImage(base64Images.value);
        }
      };
    }
  };
  reader.readAsDataURL(file);
}

function onFileChange(e) {
  const files = e.target.files || e.dataTransfer.files;
  if (!files.length) {
    return;
  }
  Array.from(files).forEach((file) => {
    createImage(file, files.length);
  });
}
</script>
